import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full px-6 py-10" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-204">
          <img src="https://cdn.magicpatterns.com/uploads/vKKVZ4kdxjo3h8xamoVawc/private_openrouter-generated-image-1775120618396.png" alt="Persona despierta en la cama sin poder dormir" className="w-full max-w-2xl mx-auto rounded-xl mb-8" data-id="element-205" />

          <div className="flex items-center gap-4 mb-8" data-id="element-206">
            <RefreshCw className="w-8 h-8 text-muted-teal" strokeWidth={1.5} data-id="element-207" />
            <h2 className="font-playfair text-3xl md:text-4xl font-bold" data-id="element-208">
              El ciclo que te tiene atrapado
            </h2>
          </div>

          <p className="text-lg md:text-xl mb-6" data-id="element-209">Piénsalo por un momento.</p>

          <p className="text-lg md:text-xl mb-8" data-id="element-210">
            Te acuestas cansado. La mente empieza. Intentas calmarte. Eso te
            pone más nervioso. Duermes mal. Al día siguiente estás irritable,
            tenso, con poca energía. Eso genera más ansiedad. Y la noche
            siguiente... se repite.
          </p>

          <p className="text-lg md:text-xl mb-8" data-id="element-211">
            Es el bucle perfecto. Cruel. Y completamente invisible para quien
            está dentro.
          </p>

          <p className="text-lg md:text-xl mb-12" data-id="element-212">
            Lo peor no es el cansancio. Lo peor es esa sensación constante de ir
            un paso por detrás de todo. De funcionar, pero apenas. De sonreír,
            pero con el pecho apretado. De tener una vida que "sobre el papel"
            no debería generar tanto estrés, y sin embargo...
          </p>

          <div className="space-y-6 my-12 pl-6 border-l-2 border-amber-gold" data-id="element-213">
            <p className="text-xl md:text-2xl font-playfair italic text-amber-gold" data-id="element-214">
              ¿Cuándo fue la última vez que te despertaste sintiéndote realmente
              descansado?
            </p>
            <p className="text-xl md:text-2xl font-playfair italic text-amber-gold" data-id="element-215">
              ¿Cuándo fue la última vez que pasaste un día entero sin esa
              tensión de fondo, ese estado de alerta que no sabes bien a qué
              responde?
            </p>
          </div>

          <p className="text-lg md:text-xl font-medium" data-id="element-216">
            Si tienes que pensarlo mucho, esta carta es para ti.
          </p>
        </motion.div>
      </div>
    </section>;
}